module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editTrainingModule":"Edit a module"},"fr":{"editTrainingModule":"Editer un module"}}')
  delete Component.options._Ctor
}
